<template>
  <div>
    <!--      -->
    <router-view />
    <div v-if="isLoaderActive" class="text-center flex items-center justify-center h-screen">
      <v-progress-circular class="text-primary" :size="75" indeterminate />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, onBeforeUnmount, onMounted } from 'vue';
import { useLocalizationStore } from '@/store/modules/useLocalizationStore';
import { usePusher } from '@/composables/usePusher';
import { useUiStore } from '@/store/modules/useUiStore';
import { storeToRefs } from 'pinia';
import { useBarcodeScanner } from '@/composables/useBarcodeScanner';

export default defineComponent({
  name: 'App',
  setup() {
    const localizationStore = useLocalizationStore();
    const uiStore = useUiStore();
    const { isLoaderActive } = storeToRefs(uiStore);

    const { initializePusher } = usePusher();
    useBarcodeScanner();

    const windowPasteHandler = (event: Event) => {
      const target = event.target;

      if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) {
        setTimeout(() => {
          target.value = target.value.trim();
          target.dispatchEvent(new Event('input'));
        }, 0);
      }
    };

    onMounted(() => {
      window.addEventListener('paste', windowPasteHandler);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('paste', windowPasteHandler);
    });

    onBeforeMount(() => {
      initializePusher();
      uiStore.fetchOrganizationLogo();
      localizationStore.refreshLocale();
    });

    return { isLoaderActive };
  },
});
</script>
